import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Header from '../../components/Header';
import { useTranslation } from 'react-i18next';
import { Spinner } from '../../components/Spinner';
import { useSearchParams } from 'react-router';
import { makeUnauthorizedRequest } from '../../utils/makeRequest';
import { useEnv } from '../../context/env-context';
import { useCallback, useEffect, useRef, useState } from 'react';
import SupportIcon from '../../components/icons/SupportIcon';
import PhoneIcon from '../../components/icons/PhoneIcon';

function FinchConnect() {
  const { t } = useTranslation();

  const { apiOriginAggregator } = useEnv();

  const [searchParams, setSearhParams] = useSearchParams();

  const requestInProgress = useRef(false);

  const [provider, setProvider] = useState(null);
  const [isError, setIsError] = useState(false);

  const mailTo = 'mailto:support@bridgeover.io';
  const phoneTo = 'tel:18004724230';

  const saveFinchToken = useCallback(
    async code => {
      requestInProgress.current = true;

      const config = {
        url: `${apiOriginAggregator}/finch/save_token`,
        method: 'POST',
        data: JSON.stringify({ code }),
      };

      try {
        const data = await makeUnauthorizedRequest(config);

        setProvider(data);
      } catch (error) {
        setIsError(true);
      } finally {
        setSearhParams('');
        requestInProgress.current = false;
      }
    },
    [apiOriginAggregator, setSearhParams],
  );

  useEffect(() => {
    const code = searchParams.get('code');

    if (code && !requestInProgress.current) {
      saveFinchToken(code);
    }
  }, [searchParams, saveFinchToken]);

  if (isError) {
    return (
      <Container className="bo-mobile">
        <Header />
        <div className="bo-rounded-container mt-5">
          <Row className="mt-4 mx-3">
            <Col className="text-center">
              <p className="bo-text bo-larger">{t('pages.finch_connect.error.oops')}</p>
            </Col>
          </Row>
          <Row className="mt-3 mx-3">
            <Col className="text-center">
              <p className="bo-text bo-larger">{t('pages.finch_connect.error.please_contact')}</p>
            </Col>
          </Row>
          <Row className="mt-3 mb-5 mx-3">
            <Col className="text-start">
              <div>
                <div className="mb-3 d-flex">
                  <div className="bo-w-30 me-2">
                    <SupportIcon />
                  </div>
                  <div>
                    {t('pages.finch_connect.error.email_us')}
                    <a className="bo-link" href={mailTo}>
                      support@bridgeover.io
                    </a>
                  </div>
                </div>
                <div className="mb-3 d-flex">
                  <div className="bo-w-30 me-2">
                    <PhoneIcon />
                  </div>
                  <div>
                    {t('pages.finch_connect.error.call_us')}
                    <a className="bo-link" href={phoneTo}>
                      1-800-472-4230
                    </a>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    );
  }

  if (provider) {
    return (
      <Container className="bo-mobile">
        <Header />
        <div className="bo-rounded-container mt-5">
          <Row className="mt-4 mx-3">
            <Col className="text-center">
              <p className="bo-text bo-larger">{t('pages.finch_connect.success.thank_you')}</p>
            </Col>
          </Row>
          <Row className="mt-3 mx-3">
            <Col className="text-center">
              <p className="bo-text bo-larger">
                {t('pages.finch_connect.success.connection_completed')}
              </p>
            </Col>
          </Row>
          <Row className="mt-3 mx-3">
            <Col className="text-center">
              <p className="bo-text-bold">
                {t('pages.finch_connect.success.provider_connected', {
                  providerName: provider.providerName,
                  aggregatorName: provider.aggregatorName,
                })}
              </p>
            </Col>
          </Row>
          <Row className="mt-3 mb-5 mx-3">
            <Col className="text-center">
              <p className="bo-text-medium">{t('pages.finch_connect.success.close_window')}</p>
            </Col>
          </Row>
        </div>
      </Container>
    );
  }

  return (
    <Container className="bo-mobile">
      <Header />
      <div className="bo-rounded-container mt-5">
        <Row className="mt-4 mx-3">
          <Col className="text-center">
            <p className="bo-text bo-larger">{t('pages.finch_connect.please_wait')}</p>
          </Col>
        </Row>
        <Row className="bo-h-100 mb-5 mx-3 align-items-center">
          <Col className="pb-5 text-center">
            <Spinner visible contentColor="#000000" />
          </Col>
        </Row>
      </div>
    </Container>
  );
}

export default FinchConnect;
